import {API} from "../../axios/axiosMainUrl";

const prefix = '/return-parcels/dhlpl'

export const returnParcelsDHL = {
  state: {
    returnParcelsDHL: [],
    returnParcelsDHLItem: {},
    returnParcelsDHLCommonList: [],
    returnParcelsDHLBtn: false,
    returnParcelsDHLLoading: true,
    nextReturnParcelsDHLPage: false,
    returnParcelsDHLForPage: 25,
    returnParcelsDHLFilter: '',
  },

  mutations: {
    setReturnParcelsDHLFilter: (state, payload) => {
      state.returnParcelsDHLFilter = payload
    },

    setReturnParcelsDHL: (state, payload) => {
      if(state.nextReturnParcelsDHLPage) {
        state.returnParcelsDHL = state.returnParcelsDHL.concat(payload.returnParcelsDHL)
      } else {
        state.returnParcelsDHL = payload.returnParcelsDHL
      }
    },

    setReturnParcelsDHLCommonList: (state, payload) => {
      state.returnParcelsDHLCommonList = payload.returnParcelsDHLCommonList
    },

    setNextReturnParcelsDHLPage: (state, payload) => {
      state.nextReturnParcelsDHLPage = payload
    },

    setReturnParcelsDHLItem: (state, payload) => {
      state.returnParcelsDHLItem = payload.returnParcelsDHLItem
    },

    setReturnParcelsDHLLoadingStart: (state) => {
      state.returnParcelsDHLLoading = true
    },

    setReturnParcelsDHLLoadingEnd: (state) => {
      state.returnParcelsDHLLoading = false
    },

    changeReturnParcelsDHLBtn: (state) => {
      state.returnParcelsDHLBtn = true
    },
    successReturnParcelsDHLBtn: (state) => {
      state.returnParcelsDHLBtn = false
    },
  },

  getters: {
    getReturnParcelsDHLFilter: state => {
      return state.returnParcelsDHLFilter
    },

    getReturnParcelsDHLForPage: state => {
      return state.returnParcelsDHLForPage
    },

    getReturnParcelsDHL: state => {
      return state.returnParcelsDHL
    },

    getReturnParcelsDHLLoading: state => {
      return state.returnParcelsDHLLoading
    },


    getNextReturnParcelsDHLPage: state => {
      return state.nextReturnParcelsDHLPage
    },

    getReturnParcelsDHLItem: state => {
      return state.returnParcelsDHLItem
    },

    getReturnParcelsDHLCommonList: state => {
      return state.returnParcelsDHLCommonList
    },

    getReturnParcelsDHLBtn: state => {
      return state.returnParcelsDHLBtn
    },
  },

  actions: {

    async fetchReturnParcelsDHL({commit, getters}, filter = '') {
      if(!getters.getNextReturnParcelsDHLPage)
        commit('setReturnParcelsDHLLoadingStart')
      try {
        return await API.get(`${prefix}${filter}`).then((response) =>{
          commit('setReturnParcelsDHL',{returnParcelsDHL: response.data.data.data})
          commit('setReturnParcelsDHLCommonList',{returnParcelsDHLCommonList: response.data.data})
          commit('setReturnParcelsDHLLoadingEnd');
          return response;
        });
      } catch (e) {
        commit('setReturnParcelsDHLLoadingEnd');
        return e;
      }
    },

    async getReturnParcelsDHL({commit}, id) {
      commit('setReturnParcelsDHLLoadingStart');
      try {
        return await API.get(`${prefix}/${id}`).then((response) =>{
          commit('setReturnParcelsDHLItem', {returnParcelsDHLItem: response.data.data})
          commit('setReturnParcelsDHLLoadingEnd');
          return response;
        });
      } catch (e) {
        commit('setReturnParcelsDHLLoadingEnd');
        return e;
      }
    },

    async checkOrderReturnParcelsDHL({commit}, data) {
      commit('setReturnParcelsDHLLoadingStart');
      try {
        return await API.get(`${prefix}/resolve-order?order_type=${data.order_type}&order_id=${data.order_id}`).then((response) =>{
          commit('setReturnParcelsDHLLoadingEnd');
          return response;
        });
      } catch (e) {
        commit('setReturnParcelsDHLLoadingEnd');
        return e;
      }
    },

    async getSavedAddressesReturnParcelsDHL() {
      // commit('changeReturnParcelsDHLBtn');
      try {
        return await API.get(`${prefix}/save-address`).then((response) =>{
          // commit('successReturnParcelsDHLBtn');
          return response;
        });
      } catch (e) {
        // commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async getPriceReturnParcelsDHL({commit}, data) {
      commit('changeReturnParcelsDHLBtn');
      try {
        return await API.post(`${prefix}/get-price`, data).then((response) =>{
          commit('successReturnParcelsDHLBtn');
          return response;
        });
      } catch (e) {
        commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async makeLabelReturnParcelsDHL({commit}, data) {
      commit('changeReturnParcelsDHLBtn');
      try {
        return await API.post(`${prefix}/make-label`, data).then((response) =>{
          commit('successReturnParcelsDHLBtn');
          return response;
        });
      } catch (e) {
        commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async createReturnParcelsDHLByOrder({commit}, data) {
      commit('changeReturnParcelsDHLBtn');
      try {
        return await API.post(`${prefix}`, data).then((response) =>{
          commit('successReturnParcelsDHLBtn');
          return response;
        });
      } catch (e) {
        commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async createReturnParcelsDHL({commit}, data) {
      commit('changeReturnParcelsDHLBtn');
      try {
        return await API.post(`${prefix}/manual`, data).then((response) =>{
          commit('successReturnParcelsDHLBtn');
          return response;
        });
      } catch (e) {
        commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async updateReturnParcelsDHL({commit}, {id, data}) {
      commit('changeReturnParcelsDHLBtn');
      try {
        return await API.put(`${prefix}/${id}`, data).then((response) =>{
          commit('successReturnParcelsDHLBtn');
          return response;
        });
      } catch (e) {
        commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async deleteReturnParcelsDHL({commit}, id) {
      try {
        return await API.delete(`${prefix}/${id}`).then((response) =>{
          return response;
        });
      } catch (e) {
        commit('successReturnParcelsDHLBtn');
        return e;
      }
    },

    async getExportReturnParcelsDHL({commit}, {filter, type}) {
      commit('setExportBtnLoadingStart')
      commit('setLoadingEnd')
      try {
        return await API.get(`${prefix}/export/${type}${filter}`, { responseType: 'blob' }).then((response) =>{
          commit('setExportBtnLoadingEnd')
          return response
        })
      } catch (e) {
        commit('setExportBtnLoadingEnd')
        return e;
      }
    },

  }
}
